module.exports = __webpack_public_path__ + "img/9788960172517.00ce54d1.jpg";